/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Injectable } from '@angular/core';
import {
    Actions,
    createEffect,
    ofType,
} from '@ngrx/effects';

import { map, switchMap } from 'rxjs/operators';
import { AppInsightsService } from './app-insights.service';
import * as AppInsightsActions from './app-insights.actions';

@Injectable()
export class AppInsightsEffects {
    /**
     * Fetches App Insights information to store.
     */
    public fetchAppInsights$ = createEffect(() => this.actions$.pipe(
        ofType(AppInsightsActions.loadAppInsights),
        switchMap(({ vsId }) => {
            return this.appInsightsService.fetchAppInsightsData(vsId)
                .pipe(
                    map(appInsights => {
                        return AppInsightsActions.loadAppInsightsSuccess({
                            vsId,
                            data: appInsights,
                            lastUpdatedTimestamp: Date.now(),
                        });
                    }),
                );
        }),
    ));

    constructor(
        private readonly actions$: Actions,
        private readonly appInsightsService: AppInsightsService,
    ) {}
}
